/** The computed box properties `drawnScale` reads. */
export type DrawnScaleStyle = Pick<
  CSSStyleDeclaration,
  | "width"
  | "boxSizing"
  | "paddingLeft"
  | "paddingRight"
  | "borderLeftWidth"
  | "borderRightWidth"
>;

/**
 * How large an element is drawn relative to its layout size: its bounding
 * width over its computed border-box width. An ancestor's transform scales
 * the first and not the second. The detail overlay enters from
 * `scale(0.985)`, and a label measured during that entrance read its glyphs
 * at the scaled size against its unscaled layout width, so it kept a
 * character that no longer fit once the scale reached 1.
 *
 * A computed width that is not a length, such as an inline box's `auto`, or a
 * box with no width reads as unscaled.
 */
export function drawnScale(box: { width: number }, style: DrawnScaleStyle) {
  let width = Number.parseFloat(style.width);
  if (style.boxSizing !== "border-box") {
    width +=
      Number.parseFloat(style.paddingLeft) +
      Number.parseFloat(style.paddingRight) +
      Number.parseFloat(style.borderLeftWidth) +
      Number.parseFloat(style.borderRightWidth);
  }
  const scale = box.width / width;
  return Number.isFinite(scale) && scale > 0 ? scale : 1;
}
